export type BrandEnvironment = "production" | "staging";

/** Host detection covers the login page and Pages previews before ledger data arrives. */
export function brandingEnvironment(
  environment?: string,
  hostname = window.location.hostname,
): BrandEnvironment {
  if (environment === "production" || environment === "staging") return environment;
  return /(^|\.)barnyard-expenses-staging\.pages\.dev$/.test(hostname)
    ? "staging"
    : "production";
}

export function brandingIcon(environment: BrandEnvironment, size: number): string {
  return `/icons/barnyard-owl-${environment === "staging" ? "amber" : "mint"}-${size}.png`;
}

/** Both environments ship the same artifact; branding is selected at runtime. */
export function applyDocumentBranding(environment: BrandEnvironment) {
  const tone = environment === "staging" ? "amber" : "mint";
  const links = {
    'link[rel="icon"]': brandingIcon(environment, 32),
    'link[rel="apple-touch-icon"]': `/icons/barnyard-owl-${tone}-apple-touch.png`,
    'link[rel="manifest"]': environment === "staging"
      ? "/manifest-staging.webmanifest"
      : "/manifest.webmanifest",
  };
  for (const [selector, href] of Object.entries(links)) {
    const link = document.querySelector<HTMLLinkElement>(selector);
    if (link && link.getAttribute("href") !== href) link.setAttribute("href", href);
  }
}
